import { attachAccordionHandlers } from "../ui/accordion";

export function attachProductEvents() {
  attachAccordionHandlers();

  window.onload = showFeefoReviews;

  $(document).on("click", ".feefo-link", scrollToFeefoReviews);
}

var selectors = {
  videoButton: ".product__videoButton",
  videoAccordion: "#video-accordion"
}

var videoButtonElement = document.querySelector(selectors.videoButton);

if(videoButtonElement) {
  videoButtonElement.addEventListener("click", scrollToVideo);
}

function scrollToFeefoReviews() {
  var reviews_accordion = $('.reviews-accordion')

  reviews_accordion.addClass('opened')

  $('html,body').animate({
    scrollTop: reviews_accordion.offset().top
  }, 500);
}

function showFeefoReviews() {
  if (document.querySelector(".feefo-block") && document.querySelector(".feefo-product-stars-widget").innerText.length != 0) {
    document.querySelector(".feefo-block").style.removeProperty('display');
    document.querySelector(".reviews-accordion").classList.remove("hidden");
  }
}

function scrollToVideo(event) {
  event.preventDefault();
  var videoAccordionElement = $(selectors.videoAccordion);

  videoAccordionElement.addClass('opened');

  $('html,body').animate({
    scrollTop: videoAccordionElement.offset().top
  }, 500);
}

